import 'angular:locale/data:en';
import 'angular:locale/data:de';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
